import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SoftUIControllerProvider } from "context";
import "react-toastify/dist/ReactToastify.css";
import "react-tabs/style/react-tabs.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SoftUIControllerProvider>
    <App />
  </SoftUIControllerProvider>
);

reportWebVitals();
